import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { PALETTE_COLORS } from '@/constant/unit/color';
import { BackButton, ForwardButton } from '../../component/atom/Button';
import { LinkButton } from '../../component/atom/Button/LinkButton';
import Header from '../../component/atom/Header';
import { Search } from '../../component/atom/Icon';
import Label from '../../component/atom/Label';
import CheckCard from '../../component/composite/Card/CheckCard';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import { S } from './style';
import { APP } from '../../config/app';
import { HOME_CARE_TITLE } from '../../config/option';
import noResultImg from '../../asset/noData.svg';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/hospital'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/hospital'].title}/>);
const renderTitleDescription = () => (<>
    <S.LayoutTitleDescription>
      <S.Title>🏥 醫院照顧：</S.Title>
      <S.Description>請選擇病患所在醫院</S.Description>
    </S.LayoutTitleDescription>
    <S.LayoutTitleDescription>
      <S.Title>🏠 {HOME_CARE_TITLE}：</S.Title>
      <S.Description>請選擇居家鄰近醫院</S.Description>
    </S.LayoutTitleDescription>
  </>);
const renderHospitalPlaceholderList = ({ hospitalOptionDisplayList, shouldRenderLoadMoreButton, getIsHospitalSelected, handleHospitalCardClick, handleLoadMoreButtonClick, }) => (<S.HospitalList>
    {hospitalOptionDisplayList.map((hospital) => (<CheckCard key={`${hospital.city}-${hospital.name}`} isChecked={getIsHospitalSelected({ hospital })} onCardClick={() => handleHospitalCardClick({ hospital })} cardTitle={hospital.name} cardText={hospital.address}/>))}
    {shouldRenderLoadMoreButton ? (<S.LayoutLoadMoreButton>
        <LinkButton handleClick={handleLoadMoreButtonClick}>載入更多</LinkButton>
      </S.LayoutLoadMoreButton>) : null}
  </S.HospitalList>);
const renderSearchResultList = ({ hasNoSearchResult, searchResultList, getIsHospitalSelected, handleHospitalCardClick, }) => {
    if (hasNoSearchResult)
        return (<S.LayoutNoResult src={noResultImg}>
        <S.NoResultFeedbackText>
          ＊找不到符合的資料，請確認您輸入的醫院名稱是否正確。
        </S.NoResultFeedbackText>
      </S.LayoutNoResult>);
    return (<S.HospitalList>
      {searchResultList.map((hospital) => (<CheckCard key={hospital.address} isChecked={getIsHospitalSelected({ hospital })} onCardClick={() => handleHospitalCardClick({ hospital })} cardTitle={hospital.name} cardText={hospital.address}/>))}
    </S.HospitalList>);
};
const renderFooter = ({ shouldShow, isForwardButtonAvailable, handleBackButtonClick, handleForwardButtonClick, }) => shouldShow ? (<S.LayoutFooter>
      <BackButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleBackButtonClick}>
        上一步
      </BackButton>
      <S.GapRow width={40}/>
      <ForwardButton size={BUTTON_SIZE.LARGE} isAvailable={isForwardButtonAvailable} onButtonClick={handleForwardButtonClick}>
        下一步
      </ForwardButton>
    </S.LayoutFooter>) : null;
const renderSearchInput = ({ searchInputText, handleSearchInputChange, }) => (<>
    <S.LayoutLabel>
      <Label title='選擇所在或鄰近醫院'/>
    </S.LayoutLabel>
    <S.SearchBox>
      <S.SearchBoxInput type='text' placeholder='請輸入您的醫院名稱' value={searchInputText} onChange={handleSearchInputChange}/>
      <S.SearchBoxIcon>
        <Search size='22px' color={PALETTE_COLORS.NEUTRAL_800}/>
      </S.SearchBoxIcon>
    </S.SearchBox>
  </>);
export default function View({ 
// data
isLoading, searchInputText, hospitalOptionDisplayList, shouldRenderLoadMoreButton, searchResultList, shouldShowSearchResult, isForwardButtonAvailable, hasNoSearchResult, pageHeight, 
// func
getIsHospitalSelected, handleHospitalCardClick, handleSearchInputChange, handleLoadMoreButtonClick, handleBackButtonClick, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    const titleDescription = useMemo(() => renderTitleDescription(), []);
    const searchInput = useMemo(() => renderSearchInput({ searchInputText, handleSearchInputChange }), [searchInputText, handleSearchInputChange]);
    const footer = useMemo(() => renderFooter({
        shouldShow: !hasNoSearchResult,
        isForwardButtonAvailable,
        handleBackButtonClick,
        handleForwardButtonClick,
    }), [hasNoSearchResult, isForwardButtonAvailable, handleBackButtonClick, handleForwardButtonClick]);
    return (<RWDPageLayout isLoading={isLoading}>
      {header}
      <S.Layout pageHeight={pageHeight}>
        {titleDescription}
        <S.LayoutHospitalSearchSection>
          {searchInput}
          {shouldShowSearchResult
            ? renderSearchResultList({
                hasNoSearchResult,
                searchResultList,
                getIsHospitalSelected,
                handleHospitalCardClick,
            })
            : renderHospitalPlaceholderList({
                hospitalOptionDisplayList,
                shouldRenderLoadMoreButton,
                getIsHospitalSelected,
                handleHospitalCardClick,
                handleLoadMoreButtonClick,
            })}
        </S.LayoutHospitalSearchSection>
        {footer}
      </S.Layout>
    </RWDPageLayout>);
}
